import type { ReactNode } from "react";
import styles from "./PageCard.module.css";

/**
 * The framed card the dry-hire catalogue sits in: a document to work down
 * rather than a question to answer, so it keeps a card where the rest of
 * the inquiry flow is the full-bleed InquiryShell. It grows with its
 * content, on the warm stone page.
 */
export default function PageCard({ children }: { children: ReactNode }) {
  return (
    <main className={styles.page}>
      <div className={styles.inner}>
        <div className={styles.card}>
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </main>
  );
}
